module.exports = new __parcel__URL__("duststorm.9734ab49.png").toString();